import { canUseWebp } from 'helpers/canUseWebp';

export const CanUseWebp = canUseWebp();
